export const roleTypesTranslationParse: { [key: string]: string } = {
  BORROWER: 'Tomador',
  EMPLOYER: 'Empregador',
  GUARANTOR: 'Avalista',
  CO_SIGNER: 'Anuente',
};
